import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import logger from '../../utils/logger';
import CONSTANTS from './constants';

function BackgroundMusic({ audioRef, gameState, musicMuted, audios, endAudios }) {
  // Randomly select an audio and endAudio on first load
  const [selectedAudio] = useState(
    audios[Math.floor(Math.random() * audios.length)]
  );

  const [selectedEndAudio] = useState(
    endAudios.length === 0 ? null : endAudios[Math.floor(Math.random() * endAudios.length)]
  );

  useEffect(() => {

    if (!musicMuted) {
      if ((gameState === CONSTANTS.GAME_STATE_COMPLETE || gameState === CONSTANTS.GAME_STATE_REPLAY_ENDED) && selectedEndAudio !== null) {
        audioRef.current.src = selectedEndAudio;
        // Attempt to play the audio
        audioRef.current.play().catch((error) => {
          logger.error("Audio play failed:", error);
        });
      } else if ((gameState === CONSTANTS.GAME_STATE_IN_PROGRESS || gameState === CONSTANTS.GAME_STATE_REPLAYING) && (audioRef.current.currentTime === 0 || audioRef.current.paused)) {
        audioRef.current.pause();
        audioRef.current.src = selectedAudio;
        audioRef.current.play().catch((error) => {
          logger.error("Audio play failed:", error);
        });
      }
    }
  }, [gameState, musicMuted, selectedAudio, selectedEndAudio, audioRef]);

  // If musicMuted is true, do not render the audio element
  return !musicMuted ? (
    <audio ref={audioRef} loop>
      <source type="audio/mpeg" />
      Your browser does not support the audio element.
    </audio>
  ) : null;
}

BackgroundMusic.propTypes = {
    audioRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
    gameState: PropTypes.number.isRequired,
    musicMuted: PropTypes.bool.isRequired,
    audios: PropTypes.arrayOf(PropTypes.string).isRequired,
    endAudios: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default BackgroundMusic;
